import { axiosInstance as request } from '@api/rest.service'

/**
 * @description GET /to-dos/templates
 * @returns {AxiosPromise<any>}
 */
export const GET_TODOS_TEMPLATES = () => request.get('/to-dos/templates')
